import styled from 'styled-components';
import { palette } from '@dev/ee-components';
import { StyledProps } from '../TargetCampaignsProps';

export const ScreenContainer = styled.div<StyledProps>`
    input {
        padding: 0;
        border: 0; //prevent 2018 styles
    }
    & .MuiAlert-root {
        margin: 24px 0;
        color: ${palette.gray[7]};
    }
    & .MuiRadio-root {
        padding: 2px 9px;
    }
    ${({ isMobile }): string => `
        & .styledPaper {
            padding-top: ${isMobile ? '18px' : '32px'};
            padding-left: ${isMobile ? '0' : '32px'};
            padding-right: ${isMobile ? '0' : '48px'};
            background: ${isMobile ? 'none' : `${palette.basic.paper}`};
            border: ${isMobile ? 'none' : '1px solid #E2E8F0'};
        }
        & .MuiPaper-root {
            background: ${isMobile ? 'none' : `${palette.basic.paper}`};
        }
        & .paginationFooter {
            padding: ${isMobile ? '24px 0' : '12px 0'};  
            background: ${isMobile ? `${palette.basic.paper}` : 'none'};   
            border: ${isMobile ? '1px solid #E2E8F0' : 'none'};  
            border-radius: ${isMobile ? '0 0 4px 4px' : 'none'};  
        }
    `}
`;

export const SearchInputStyled = styled.div<StyledProps>`
    margin: ${({ isMobile }): string => (isMobile ? '0 0 32px' : '24px 48px')};
`;

export const TableStyled = styled.div<StyledProps>`
    ${({ isMobile }): string => `
        & .MuiTableHead-root {
            display: ${isMobile ? 'none' : 'table-header-group'};
        }
        & .MuiTableRow-root {
            display: ${isMobile ? 'flex' : 'table-row'};
            flex-direction: ${isMobile ? 'column' : 'row'};
            padding: ${isMobile ? '20px 20px' : 'none'};
            margin-bottom: ${isMobile ? '16px' : 'none'};
            background: ${isMobile ? `${palette.basic.paper}` : 'none'};
            border: ${isMobile ? '1px solid #E2E8F0' : 'none'};
            border-radius: ${isMobile ? '4px' : '0'};
            box-shadow: ${isMobile ? '0px 0px 1px #2D37481A' : 'none'};
        }
        & .MuiTableCell-alignLeft {
            border-top: ${isMobile ? 'none !important' : '1px solid #E2E8F0'};
        }
        & .MuiTableCell-body > .MuiBox-root {
            padding-top: ${isMobile ? '12px !important' : '20px'};
            padding-bottom: ${isMobile ? '12px !important' : '20px'};
        }

    `}
`;
